import partnerApi from './partnerApi'

export default partnerApi
